import * as React from 'react';
import { cn } from '../../lib/utils';

const Table = React.forwardRef(({ className, ...props }, ref) => (
  <table
    ref={ref}
    className={cn('tw-w-full tw-border-collapse tw-text-sm tw-text-slate-700 dark:tw-text-slate-200', className)}
    {...props}
  />
));
Table.displayName = 'Table';

const TableHeader = React.forwardRef(({ className, ...props }, ref) => (
  <thead
    ref={ref}
    className={cn('tw-bg-slate-100/90 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-backdrop-blur dark:tw-bg-slate-800/75', className)}
    {...props}
  />
));
TableHeader.displayName = 'TableHeader';

const TableBody = React.forwardRef(({ className, ...props }, ref) => (
  <tbody
    ref={ref}
    className={cn('tw-divide-y tw-divide-slate-100/60 dark:tw-divide-slate-800/70', className)}
    {...props}
  />
));
TableBody.displayName = 'TableBody';

const TableFooter = React.forwardRef(({ className, ...props }, ref) => (
  <tfoot
    ref={ref}
    className={cn('tw-bg-slate-100 tw-font-semibold dark:tw-bg-slate-800', className)}
    {...props}
  />
));
TableFooter.displayName = 'TableFooter';

const TableRow = React.forwardRef(({ className, ...props }, ref) => (
  <tr
    ref={ref}
    className={cn(
      'tw-border-b tw-border-slate-100/60 tw-transition-colors hover:tw-bg-slate-50/80 dark:tw-border-slate-800/70 dark:hover:tw-bg-slate-800/60',
      className,
    )}
    {...props}
  />
));
TableRow.displayName = 'TableRow';

const TableHead = React.forwardRef(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={cn(
      'tw-whitespace-nowrap tw-border-b tw-border-slate-200 tw-px-4 tw-py-3 tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600 dark:tw-border-slate-700 dark:tw-text-slate-300',
      className,
    )}
    {...props}
  />
));
TableHead.displayName = 'TableHead';

const TableCell = React.forwardRef(({ className, ...props }, ref) => (
  <td
    ref={ref}
    className={cn('tw-px-4 tw-py-3 tw-align-middle tw-text-sm tw-text-slate-700 dark:tw-text-slate-200', className)}
    {...props}
  />
));
TableCell.displayName = 'TableCell';

const TableCaption = React.forwardRef(({ className, ...props }, ref) => (
  <caption
    ref={ref}
    className={cn('tw-mt-4 tw-text-sm tw-text-slate-500 dark:tw-text-slate-400', className)}
    {...props}
  />
));
TableCaption.displayName = 'TableCaption';

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableRow,
  TableHead,
  TableCell,
  TableCaption,
};
